<template>
  <div>
    <base-bar-chart
      v-show="!printable || (!imgData && printable)"
      :height="height ? height : null"
      :chart-data="getChartData"
      :options="getChartOptions"
      @chartCreated="setChart"
    />
    <img :height="height ? height : 200" :src="imgData" v-show="printable && imgData">
  </div>
</template>

<script>
import barChartMixin from './mixins/barChartMixin';
import BaseBarChart from './base/BaseBarChart';

export default {
  name: 'BarChart',
  components: {
    BaseBarChart,
  },
  data: () => ({
    chart: null,
    imgData: null,
  }),
  props: {
    height: {
      type: Number,
    },
    printable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [barChartMixin],
  methods: {
    setChart(chart) {
      this.chart = chart;
    },
    animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    },
  },
};
</script>



// WEBPACK FOOTER //
// BarChart.vue?031306ee